import { render, staticRenderFns } from "./TableFilterable.vue?vue&type=template&id=3c238b5c&"
import script from "./TableFilterable.vue?vue&type=script&lang=js&"
export * from "./TableFilterable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports